'use strict';

module.exports = {
    getUrl: Odigeo._.constant('cancelsubscription'),

    getMethod: Odigeo._.constant('PUT'),

    requestSuccess(data) {
        Odigeo.trigger(`${this.widget.id}:cancelsubscriptionOk`, data);
    },

    requestError: Odigeo._.noop,
};
